import {
  Box,
  Button,
  CloseButton,
  Flex,
  Grid,
  GridItem,
  HStack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
} from '@chakra-ui/react'

import { Card } from '@/components/Elements'
import {
  Checkbox,
  DatePicker,
  DummyInput,
  Input,
  PriceInput,
  Select,
  Textarea,
  VersionFileInput,
} from '@/components/Form'
import { useWatch } from 'react-hook-form'

const CommercialChecklistCustomerRightSection = ({ isDisabled = false, isBooking = false }) => {
  const mainPath = isBooking ? 'booking.commercialChecklist' : 'commercialChecklist'
  const customerHasRightToTerminateContract = useWatch({ name: `${mainPath}.customerHasRightToTerminateContract` })
  const customerTerminationNotifyPeriod = useWatch({ name: `${mainPath}.customerTerminationNotifyPeriod` })

  return (
    <Card title="Customer right to terminate the contract for convenience" open>
      <Flex direction={'column'} gap={4}>
        <Grid templateColumns="repeat(12, 1fr)" gap={4}>
          <GridItem colSpan="8">
            <Select
              name={`${mainPath}.customerHasRightToTerminateContract`}
              label="Customer has right to terminate the contract for convenience"
              labelWidth={60}
              isRow
              disabled={isDisabled}
              options={[
                { value: 'yes', label: 'yes' },
                { value: 'no', label: 'no' },
              ]}
            />
          </GridItem>
        </Grid>
        {customerHasRightToTerminateContract === 'yes' && (
          <Grid templateColumns="repeat(12, 1fr)" gap={4}>
            <GridItem colSpan="8">
              <Select
                name={`${mainPath}.customerTerminationNotifyPeriod.value`}
                label="Notify period for termination without cause: "
                isRow
                labelWidth={60}
                disabled={isDisabled}
                options={[
                  { value: '30', label: '30 day notice' },
                  { value: '60', label: '60 day notice' },
                  { value: 'other', label: 'other' },
                ]}
              />
            </GridItem>
            {customerTerminationNotifyPeriod?.value === 'other' && (
              <GridItem colSpan="4">
                <Input name={`${mainPath}.customerTerminationNotifyPeriod.other`} isRow disabled={isDisabled} />
              </GridItem>
            )}
          </Grid>
        )}
      </Flex>
    </Card>
  )
}

export default CommercialChecklistCustomerRightSection
